export default {
      id: "sli-close-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#sli-close",
      toString: function () {
        return this.url;
      }
    }